import { Icon } from '@eventbrite/eds-icon';
import { NegativeIconFill } from '@eventbrite/eds-iconography';
import classNames from 'classnames';
import React, { FunctionComponent } from 'react';

import { useIsScrollableCtaExperimentEnabled } from '../../utils/hooks/statsig';

import './FooterError.scss';

export const FooterError: FunctionComponent<{ className?: string }> = ({
    children,
    className,
}) => {
    const isScrollableCtaExperimentEnabled =
        useIsScrollableCtaExperimentEnabled();

    return (
        <p
            role="alert"
            className={classNames(
                'eds-text-bm eds-text-color--error eds-align--center-vertical eds-fx--fade-in',
                isScrollableCtaExperimentEnabled
                    ? 'eds-l-mn-up-mar-bot-8'
                    : 'validation-error-text',
                className,
            )}
            data-testid="footer-error"
        >
            <span className="eds-l-mar-right-1">
                <Icon type={<NegativeIconFill />} color="ui-red" />
            </span>
            {children}
        </p>
    );
};
